import { scaleW } from '@/common/style';
import React, { useEffect, useRef } from 'react';
import { Animated, View, ViewStyle } from 'react-native';

const Styles = {
    container: {},
    line: {
        height: 24,
        marginBottom: 6,
    },
    ske: {
        backgroundColor: '#f2f2f2',
        opacity: 0.6,
    },
} as { [key: string]: ViewStyle };

export function CouponPopupSke() {
    const opacityAnim = useRef(new Animated.Value(0)).current;

    useEffect(() => {
        Animated.loop(
            Animated.sequence([
                Animated.timing(opacityAnim, {
                    toValue: 1,
                    duration: 600,
                    useNativeDriver: true,
                }),
                Animated.timing(opacityAnim, {
                    toValue: 0.6,
                    duration: 600,
                    useNativeDriver: true,
                }),
            ])
        ).start();
    }, [opacityAnim]);

    const skeView = style => <Animated.View style={[Styles.line, Styles.ske, { opacity: opacityAnim }, style]} />;

    return (
        <View
            style={{"width":"100%","height":"100%"}}>
            <View
                style={{"flexDirection":"row","justifyContent":"center","marginBottom":"2.8985507246376816rem"}}>
                {skeView({
                    height: scaleW(40),
                    width: scaleW(180),
                    borderRadius: scaleW(6),
                    marginVertical: scaleW(16),
                })}
            </View>
            <View
                style={{"marginHorizontal":"2.8985507246376816rem"}}>
                <View>
                    {skeView({
                        height: scaleW(40),
                        width: scaleW(100),
                        borderRadius: scaleW(6),
                        marginBottom: scaleW(12),
                    })}
                </View>
                <View>
                    {skeView({
                        height: scaleW(80),
                        width: '100%',
                        borderRadius: scaleW(6),
                        marginBottom: scaleW(12),
                    })}
                </View>
                <View>
                    {skeView({
                        height: scaleW(80),
                        width: '100%',
                        borderRadius: scaleW(6),
                        marginBottom: scaleW(12),
                    })}
                </View>
                <View>
                    {skeView({
                        height: scaleW(80),
                        width: '100%',
                        borderRadius: scaleW(6),
                        marginBottom: scaleW(12),
                    })}
                </View>
                <View>
                    {skeView({
                        height: scaleW(80),
                        width: '100%',
                        borderRadius: scaleW(6),
                        marginBottom: scaleW(12),
                    })}
                </View>
            </View>
        </View>
    );
}
